export const ProductionSimulationWarehouseItem = (
	json: IProductionSimulationWarehouseItem,
): IProductionSimulationWarehouseItemModel => {
	const {
		id,
		itemCrmId,
		requiredQuantity,
		availableQuantity,
		missingQuantity,
		issuedQuantity,
		unit,
		netPrice,
		grossPrice,
		totalNetPrice,
		totalGrossPrice,
		itemType,
		name,
		status,
		category,
	} = json

	return {
		id,
		requiredQuantity,
		availableQuantity,
		missingQuantity,
		issuedQuantity,
		unit,
		netPrice,
		grossPrice,
		totalNetPrice,
		totalGrossPrice,
		itemType,
		name,
		status,
		category,
		itemCrmID: itemCrmId,
	}
}

export const ProductionSimulationWarehouse = (
	json: IProductionSimulationWarehouse,
): IProductionSimulationWarehouseModel => {
	const { items, productionPlanId, productionSimulationId, reservationId, status } = json

	return {
		items: items.map(ProductionSimulationWarehouseItem),
		productionPlanID: productionPlanId,
		productionSimulationID: productionSimulationId,
		reservationID: reservationId,
		status,
	}
}

export const ProductionSimulationMaterialRecipeReservation = (
	json: IProductionSimulationMaterialRecipeReservation,
): IProductionSimulationMaterialRecipeReservationModel => {
	const { requiredQuantity, availableQuantity, missingQuantity, issuedQuantity, netPrice, grossPrice } = json

	return {
		requiredQuantity,
		availableQuantity,
		missingQuantity,
		issuedQuantity,
		netPrice,
		grossPrice,
	}
}

export const ProductionSimulationMaterialRecipeAllergen = (
	json: IProductionSimulationMaterialRecipeAllergen,
): IProductionSimulationMaterialRecipeAllergenModel => {
	const { name, code } = json

	return { name, code }
}

export const ProductionSimulationMaterialRecipeMeal = (
	json: IProductionSimulationMaterialRecipeMeal,
): IProductionSimulationMaterialRecipeMealModel => {
	const { id, productionMealId, thumbUrl, kitchenThumbUrl, allergens, ...rest } = json

	return {
		id,
		productionMealID: productionMealId,
		thumbURL: thumbUrl,
		kitchenThumbURL: kitchenThumbUrl,
		allergens: allergens.map(ProductionSimulationMaterialRecipeAllergen),
		...rest,
	}
}

export const ProductionSimulationMaterialRecipe = (
	json: IProductionSimulationMaterialRecipe,
): IProductionSimulationMaterialRecipeModel => {
	const { meals, ...rest } = json

	return {
		meals: meals.map(ProductionSimulationMaterialRecipeMeal),
		...rest,
	}
}

export const ProductionSimulationMaterialRecipesItem = (
	json: IProductionSimulationMaterialRecipesItem,
): IProductionSimulationMaterialRecipesItemModel => {
	const { id, itemCrmId, externalId, reservation, allergens, recipes, ...rest } = json

	return {
		id,
		itemCrmID: itemCrmId,
		externalID: externalId,
		reservation: ProductionSimulationMaterialRecipeReservation(reservation),
		allergens: allergens.map(ProductionSimulationMaterialRecipeAllergen),
		recipes: recipes.map(ProductionSimulationMaterialRecipe),
		...rest,
	}
}

export const ProductionSimulationMaterialRecipesResponse = (
	json: IProductionSimulationMaterialRecipesResponse,
): IProductionSimulationMaterialRecipesResponseModel => {
	const { items, productionSimulationId, ...rest } = json

	return {
		items: items.map(ProductionSimulationMaterialRecipesItem),
		productionSimulationID: productionSimulationId,
		...rest,
	}
}
